import { useQuery } from '@tanstack/react-query';
import { SettingsService, TourConfig } from '@/shared/services/api/SettingsService';

interface UseTourSettingsOptions {
  enabled?: boolean;
}

/**
 * Hook para buscar as configurações do tour do backend
 * @param options - Opções do hook, incluindo enabled para controlar execução
 */
export function useTourSettings(options?: UseTourSettingsOptions) {
  return useQuery<TourConfig>({
    queryKey: ['tour-settings'],
    queryFn: () => SettingsService.getTourSettings(),
    enabled: options?.enabled ?? true,
    staleTime: 1000 * 60 * 60, // 1 hora - configurações não mudam com frequência
    gcTime: 1000 * 60 * 60 * 24, // 24 horas
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
}
